import React, { useState, useEffect } from 'react';
import Select from '../subcomponents/Select';
import { toast } from 'react-toastify';

// Ways a car gets paid for that this app never processes. Checks are entered
// from Admin Panel -> Manage Payments instead, because one check can cover cars
// belonging to several registrants and that does not fit a single-entry modal.
const OTHER_METHODS = ['Square POS', 'Cash', 'Comped', 'Other'];

const EntryModal = ({ isOpen, title, entry, onClose, refresh }) => {
  const [mode, setMode] = useState('view');
  const [payMethod, setPayMethod] = useState(OTHER_METHODS[0]);

  useEffect(() => {
    if (isOpen) {
      setMode('view');
      setPayMethod(OTHER_METHODS[0]);
    }
  }, [isOpen, entry]);

  const currentDomain = () => {
    //if location origin starts with localhost, return localhost:3001
    if (location.origin.startsWith('http://localhost')) {
      return 'http://localhost:3001';
    } else {
      return location.origin;
    }
  }

  const handleMarkPaid = (carUUID) => {
    fetch(`${currentDomain(location)}/api/payments/markpaid/${carUUID}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: payMethod }),
    })
      .then((response) => {
        if (response.ok) {
          toast.success(`Entry marked as paid (${payMethod}).`);
          onClose();
        } else {
          throw new Error('Failed to mark entry as paid.');
        }
      })
      .catch((error) => {
        toast.error('Error marking entry as paid:', error);
      });
  }

  const handleDelete = () => {
    toast(`Delete ${entry.car_id}`);
  }


  const handleCopy = (label, value) => {
    navigator.clipboard.writeText(value)
      .then(() => {
        toast.success(`${label} copied to clipboard.`);
      })
      .catch(() => {
        toast.error(`Failed to copy ${label}.`);
      });
  }

  const handChangeClass = (value, vehicle) => {
    console.log(vehicle)
    console.log(value)
    fetch(`${currentDomain(location)}/api/entries/class/${value}/${vehicle.car_id}/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.ok) {
        toast.success('Entry class updated.');
        onClose();
      } else {
        throw new Error();
      }
    }).catch((error) => {
      toast.error('Error updating entry class:', error);
    });
  }



  return (
    <>
      {isOpen && (

        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black opacity-50"></div>

          {/* Modal Content */}
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full">
            {/* Modal Header */}


            {/* Modal Body: Display the entry details */}
            {entry ? (

              <div>
                {mode === 'view' && (
                  <>
                    {/** Entry Details */}
                    <div className="mb-4">
                      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                        <p><strong>Year:</strong> {entry.year}</p>
                        <p><strong>Make:</strong> {entry.make}</p>
                        <p><strong>Model:</strong> {entry.model}</p>
                        <p><strong>Class:</strong> {entry.class_name}</p>
                        <p><strong>Owner:</strong> {entry.owner_first_name} {entry.owner_last_name}</p>
                        <p>
                          <strong>Paid:</strong> {entry.ispaid ? 'Yes' : 'No'}
                          {entry.ispaid && entry.payment_method && (
                            <span className="text-gray-500 text-sm">
                              {' '}({entry.payment_note || entry.payment_method})
                            </span>
                          )}
                        </p>
                        <p><strong>Phone:</strong> {entry.owner_phone}</p>
                      </div>

                      <div className="mt-3 pt-3 border-t border-gray-200 space-y-1">
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-20">Car UUID</span>
                          <button
                            onClick={() => handleCopy('Car UUID', entry.car_id)}
                            className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded font-mono truncate"
                            title="Copy Car UUID"
                          >
                            {entry.car_id}
                          </button>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-20">Owner UUID</span>
                          <button
                            onClick={() => handleCopy('Owner UUID', entry.owner_id)}
                            className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded font-mono truncate"
                            title="Copy Owner UUID"
                          >
                            {entry.owner_id}
                          </button>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500 w-20">Class UUID</span>
                          <button
                            onClick={() => handleCopy('Class UUID', entry.class_id)}
                            className="text-xs bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded font-mono truncate"
                            title="Copy Class UUID"
                          >
                            {entry.class_id}
                          </button>
                        </div>

                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-end gap-2 w-full">
                      <button
                        onClick={() => setMode('edit')}
                        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
                      >
                        Edit
                      </button>
                      <button
                        onClick={onClose}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                      >
                        Close
                      </button>
                    </div>
                  </>
                )}

                {mode === 'edit' && (
                  <div>
                    <div className="mb-4 space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Competition Class</label>
                        <Select.SingleVehicleClass
                          onChange={handChangeClass}
                          value={entry.class_id}
                          vehicle={entry}
                        />
                      </div>

                      <div className="pt-4 border-t border-gray-200">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Mark Paid</label>
                        <div className="flex gap-2">
                          <select
                            value={payMethod}
                            onChange={(e) => setPayMethod(e.target.value)}
                            className="flex-1 min-w-0 border border-gray-300 rounded px-2 py-2 text-sm"
                          >
                            {OTHER_METHODS.map((m) => (
                              <option key={m} value={m}>{m}</option>
                            ))}
                          </select>
                          <button
                            onClick={() => handleMarkPaid(entry.car_id)}
                            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 shrink-0"
                          >
                            Mark Paid
                          </button>
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                          Paying by check? Use Admin Panel &rarr; Manage Payments, so the check is
                          recorded and can cover cars under other names.
                        </p>
                      </div>

                      <div className="pt-4 border-t border-gray-200">
                        <button
                          onClick={handleDelete}
                          className="w-full bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                        >
                          Delete Entry
                        </button>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-between items-center w-full pt-4 border-t border-gray-200">
                      <button
                        onClick={() => setMode('view')}
                        className="text-sm text-gray-500 hover:text-gray-700"
                      >
                        &larr; Back to details
                      </button>
                      <button
                        onClick={onClose}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                )}
              </div>

            ) : (
              <p>No entry selected.</p>
            )}



          </div>
        </div>
      )}
    </>
  );
};

export default EntryModal;
